module.exports = __webpack_public_path__ + "static/media/skills.958b12c3.svg";